"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgTemplateRolloutRenderFactory = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const consts_1 = require("@opsbase/lib-time/consts");
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    root: {
        padding: '0 8px',
        lineHeight: '23px',
        backgroundColor: lib_palette_1.default.positive.main,
        color: lib_palette_1.default.primary.contrastText,
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
    },
});
const OrgTemplateRolloutRenderFactory = () => (item) => {
    var _a, _b;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    if (item.requiresRollOut) {
        return (react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Text_1.default, null, (_a = item.lastRolledOutDate) === null || _a === void 0 ? void 0 : _a.format(consts_1.SimpleDateFormat)),
            react_1.default.createElement(Text_1.default, { variant: "small", className: myCss.root }, lib_i18n_1.default.t('changes-to-rollout'))));
    }
    else {
        return react_1.default.createElement(Text_1.default, null, (_b = item.lastRolledOutDate) === null || _b === void 0 ? void 0 : _b.format(consts_1.SimpleDateFormat));
    }
};
exports.OrgTemplateRolloutRenderFactory = OrgTemplateRolloutRenderFactory;
exports.default = exports.OrgTemplateRolloutRenderFactory;
